import { render, staticRenderFns } from "./EndorseButton.vue?vue&type=template&id=f45c4890&scoped=true&"
import script from "./EndorseButton.vue?vue&type=script&lang=js&"
export * from "./EndorseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45c4890",
  null
  
)

export default component.exports